export function getSections() {
  return {
    recent: {
      name: 'recent',
      params: {
        recent: true,
      },
    },
    new: {
      name: 'new',
      params: {
        tags: ['new'],
        order: 'sort_order',
      },
    },
    popular: {
      name: 'popular',
      params: {
        tags: ['popular'],
        order: 'sort_order',
      },
    },
    featured: {
      name: 'featured',
      params: {
        tags: ['featured'],
        order: 'sort_order',
      },
    },
    favorite: {
      name: 'favorite',
      params: {
        tags: ['sagaLikes'],
        order: 'sort_order',
      },
    },
    slots: {
      name: 'slots',
      params: {
        tags: ['slots'],
      },
    },
    blitz: {
      name: 'blitz',
      params: {
        tags: ['blitz'],
        order: 'sort_order',
      },
    },
    jackpot: {
      name: 'jackpot',
      params: {
        jackpot: true,
        order: 'sort_order',
      },
    },
    roulette: {
      name: 'roulette',
      params: {
        tags: ['roulette_redirect'],
        order: 'sort_order',
      },
      directLaunch: true,
    },
    blackjack: {
      name: 'blackjack',
      params: {
        tags: ['blackjack_redirect'],
      },
      directLaunch: true,
    },
    'table-games': {
      name: 'tableGames',
      params: {
        tags: ['table-games'],
        order: 'sort_order',
      },
    },
    scratch: {
      name: 'scratch',
      params: {
        tags: ['scratch'],
      },
    },
  }
}
